import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
const routes = [
  {
    path: "/",
    component: () => import("../views/home.vue"),
  },
  {
    path: "/login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/test",
    component: () => import("../views/test.vue"),
  },
  {
    path: "/report",
    component: () => import("../views/report.vue"),
  },
  {
    path: "/result",
    component: () => import("../views/result.vue"),
  },
  {
    path: "/select-role",
    component: () => import("../views/select-role.vue"),
  },
  {
    path: "/history",
    component: () => import("../views/history.vue"),
  },
  {
    path: "/create-group",
    component: () => import("../views/create-group.vue"),
  },
  {
    path: "/report-group",
    component: () => import("../views/report-group.vue"),
  },
  {
    path: "/others/home",
    component: () => import("../views/others/home.vue"),
  },
  {
    path: "/others/test",
    component: () => import("../views/others/test.vue"),
  },
  {
    path: "/others/result",
    component: () => import("../views/others/result.vue"),
  },
  {
    path: "/others/select-role",
    component: () => import("../views/others/select-role.vue"),
  },
  {
    path: "/others/report-other",
    component: () => import("../views/others/report-other.vue"),
  },
  // MBTI 路由

  {
    path: '/mbti',
    redirect: '/mbti/home', // 访问 /mbti 时默认重定向到首页
  },
  {
    path: '/mbti/home',
    name: 'MbtiHome',
    component: () => import('@/views/mbti/home.vue'),
    meta: { title: 'MBTI 首页' }
  },
  {
    path: '/mbti/test',
    name: 'MbtiTest',
    component: () => import('@/views/mbti/test.vue'),
    meta: { title: 'MBTI 测试' }
  },
  {
    path: '/mbti/result',
    name: 'MbtiResult',
    component: () => import('@/views/mbti/result.vue'),
    meta: { title: '测试结果' }
  },
  {
    path: '/mbti/create',
    name: 'MbtiCreate',
    component: () => import('@/views/mbti/create.vue'),
    meta: { title: '创建 MBTI' }
  },
  {
    path: '/mbti/group',
    name: 'MbtiGroup',
    component: () => import('@/views/mbti/group.vue'),
    meta: { title: '团队 / 小组' }
  },
  {
    path: '/mbti/group-home',
    name: 'MbtiGroupHome',
    component: () => import('@/views/mbti/group-home.vue'),
    meta: { title: '团队首页' }
  },
  {
    path: '/mbti/group-result',
    name: 'MbtiGroupResult',
    component: () => import('@/views/mbti/group-result.vue'),
    meta: { title: '团队结果' }
  },
  {
    path: '/mbti/join',
    name: 'MbtiJoin',
    component: () => import('@/views/mbti/join.vue'),
    meta: { title: '加入团队' }
  },
  {
    path: '/mbti/other-home',
    name: 'MbtiOtherHome',
    component: () => import('@/views/mbti/other-home.vue'),
    meta: { title: '他评首页' }
  },
  {
    path: '/mbti/other-test',
    name: 'MbtiOtherTest',
    component: () => import('@/views/mbti/other-test.vue'),
    meta: { title: '进行他评' }
  },
  {
    path: '/mbti/other-result',
    name: 'MbtiOtherResult',
    component: () => import('@/views/mbti/other-result.vue'),
    meta: { title: '他评结果' }
  },

  {
    path: '/mbti/result-share',
    name: 'MbtiResultShare',
    component: () => import('@/views/mbti/result-share.vue'),
    meta: { title: '结果分享' }
  },
  {
    path: '/mbti/tool',
    name: 'MbtiTool',
    component: () => import('@/views/mbti/tool.vue'),
    meta: { title: 'MBTI 工具' }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior() {
    return { top: 0 };
  },
  routes,
});

export default router;
